// Mock data for Elemento Design website

export const navigationItems = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/#services' },
  { name: 'Portfolio', path: '/portfolio' },
  { name: 'About', path: '/#about' }
];

export const heroContent = {
  tagline: 'Innovative Industrial Design Solutions',
  title: 'DESIGNING THE FUTURE OF PRODUCTS',
  backgroundImage: 'https://images.unsplash.com/photo-1600869009498-8d429f88d4f5?w=1920'
};

export const visionContent = {
  title: 'OUR VISION',
  description: 'At Elemento Design, we are revolutionizing the way products are designed and developed. Our team is dedicated to creating impactful and sustainable design solutions that meet the evolving needs of businesses and consumers alike. We blend creativity with engineering expertise to bring game-changing products to the market.',
  image: 'https://images.unsplash.com/photo-1739742465631-7fc17a556344?w=960'
};

export const servicesContent = [
  {
    id: 1,
    title: 'INDUSTRIAL DESIGN',
    description: 'From ideation to realization, we specialize in turning concepts into innovative product designs that resonate with your target audience.',
    image: 'https://images.unsplash.com/photo-1600697395543-ef3ee6e9af7b?w=1920',
    link: '/services/industrial-design',
    offerings: [
      'Concept Development & Ideation',
      'Sketching & Rendering',
      'User Experience Design',
      'Ergonomic Analysis',
      'Design for Manufacturing (DFM)',
      'Material Selection & Finishes'
    ]
  },
  {
    id: 2,
    title: 'CAD MODELING & ANALYSIS',
    description: 'Our CAD modeling and structural/thermal analysis capabilities ensure the integrity and performance of your designs throughout the development process.',
    // image: 'https://images.pexels.com/photos/323645/pexels-photo-323645.jpeg?w=1920',
    image: '/services/cad-modeling.png',
    link: '/services/cad-modeling',
    offerings: [
      'Parametric 2D and 3D Modelling',
      'Surface Modeling',
      'Finite Element Analysis (FEA)',
      'Computational Fluid Dynamics (CFD)',
      'Structural & Thermal Analysis',
      'Design Optimization'
    ]
  },
  {
    id: 3,
    title: 'PROTOTYPING & 3D PRINTING',
    description: 'Experience rapid prototyping and 3D printing services that bring your ideas to life with precision and efficiency.',
    image: 'https://images.unsplash.com/photo-1642969164999-979483e21601?w=1920',
    link: '/services/prototyping',
    offerings: [
      'Rapid Prototyping',
      'Multi-Material 3D Printing',
      'Design Iteration & Refinement'
    ]
  }
];

export const statsContent = [
  { value: '12+', label: 'CLIENT PROJECTS' },
  { value: '100%', label: 'PROJECT DELIVERY ON TIME' },
  { value: '90%', label: 'CLIENT SATISFACTION' },
  { value: '5+', label: 'RECOGNITIONS' }
];

export const partnersContent = [
  { 
    name: 'MECHANICAL & ELECTRICAL ENGINEERING', 
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=400&fit=crop&crop=center' 
  },
  { 
    name: 'MANUFACTURING PARTNERS', 
    image: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?w=400&h=400&fit=crop&crop=center' 
  },
  { 
    name: 'TECHNOLOGY PROVIDERS', 
    image: 'https://plus.unsplash.com/premium_photo-1683120966127-14162cdd0935?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=663' 
  },
  { 
    name: 'ACADEMICS CONSULTANCIES', 
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=400&fit=crop&crop=center' 
  }
];

// Helper function to generate local image paths
const generateLocalImages = (projectId, count = 12) => {
  const images = [];
  for (let i = 1; i <= count; i++) {
    images.push(`/projects/project-${projectId}/image-${i}.png`);
  }
  return images;
};

export const portfolioProjects = [
  {
    id: 1,
    title: 'Dewalt - Cantilever Tool Box',
    category: 'Industrial Design',
    description: 'This project addresses a market gap within the DeWalt ToughSystem 2.0 line by conceptualizing, designing, and developing a family of Cantilever Toolboxes. The cantilever design offers quick, multi-level access to tools and small components, which is crucial for professionals in construction, automotive, and manufacturing sectors.',
    detailedDescription: 'This project addresses a market gap within the DeWalt ToughSystem 2.0 line by conceptualizing, designing, and developing a family of Cantilever Toolboxes. The cantilever design offers quick, multi-level access to tools and small components, which is crucial for professionals in construction, automotive, and manufacturing sectors.  ',
    image: '/projects/project-1/image-1.png',
    images: generateLocalImages(1, 17),
    tags: ['Product Design', 'CAD Modeling', 'Prototyping', 'IoT', 'Energy Storage', 'UX Design'],
    features: [
      'Seamless Modular Integration: Fully compatible, stackable, and lockable with the DeWalt ToughSystem 2.0 modules.',
      'Quick-Access Cantilever Mechanism: Novel design providing multi-level organization and immediate access to tools and small components.',
      'Hybrid Material Construction: High-impact polypropylene resin reinforced with fiberglass for the body, with high tensile steel and aluminum for stress-bearing parts.',
      'Ergonomic Comfort: Handles feature a soft-grip Thermoplastic Elastomer (TPE) material to reduce hand fatigue.',
      'Customizable Internal Storage: Internal trays and dividers made from durable HDPE, designed to be customizable and removable.',
      'Integrated Smart Features: Design includes a slot and magnetic holder for easy-access portable boxes, and conceptualized for a detachable LED flashlight.'
    ],
    conclusion: 'This project successfully delivered a complete, validated design for a cantilever toolbox family that integrates seamlessly with the DeWalt ToughSystem 2.0. By balancing durability (reinforced polypropylene), portability (lightweight materials), and user-centered design (ergonomics and quick-access trays), the design sets a new benchmark in tool storage solutions, ready for physical prototyping and manufacturing '
  },
  {
    id: 2,
    title: 'Beldray - Steam Cleaner',
    category: 'Product Development',
    description: 'This project involved a comprehensive analysis and redesign of the existing Beldray 10-in-1 Handheld Steam Cleaner, aiming to optimize it for environmental sustainability, assembly efficiency, and manufacturing cost-effectiveness ',
    detailedDescription: 'This project involved a comprehensive analysis and redesign of the existing Beldray 10-in-1 Handheld Steam Cleaner, aiming to optimize it for environmental sustainability, assembly efficiency, and manufacturing cost-effectiveness ',
    image: '/projects/project-2/image-1.png',
    images: generateLocalImages(2, 12),
    tags: ['Industrial Design', 'Ergonomics', '3D Printing', 'User Research', 'Prototyping'],
    features: [
      'High Assembly Efficiency: Redesign achieved by replacing screw fasteners with snap-fit mechanisms, reducing complexity.',
      'Optimized Manufacturability: Changed main housing to a simple cylindrical tube shape for easier processes and minimized material waste.',
      'Ergonomic Weight Distribution: Utilizes an Archimedes&#39; principle-based design for effortless lifting and improved balance during use.',
      'Cordless &amp; Portable Design: Features a rechargeable battery pack for unrestricted movement and cleaning versatility.',
      'Informative User Interface (UI): Integrated on-board screen provides real-time monitoring of battery level, water level, and steam pressure.',
      'Enhanced Sustainability (DfE): Design uses highly recyclable materials, reinforced parts for extended lifespan, and energy-saving features.'
    ],
    conclusion: 'This project involved a comprehensive analysis and redesign of the existing Beldray 10-in-1 Handheld Steam Cleaner, aiming to optimize it for environmental sustainability, assembly efficiency, and manufacturing cost-effectiveness '
  },
  {
    id: 3,
    title: 'Crashworthiness and Roll Over Protection System (ROPS) ',
    category: 'Innovation',
    description: 'This project focused on the design and structural analysis of a Roll Over Protection System (ROPS) to enhance vehicle safety and performance.',
    detailedDescription: 'This project focused on the design and structural analysis of a Roll Over Protection System (ROPS) to enhance vehicle safety and performance.',
    image: '/projects/project-3/image-1.png',
    images: generateLocalImages(3, 4),
    tags: ['Mechanical Design', 'Innovation', 'Precision Engineering'],
    features: [
      'Enhanced Occupant Safety: Roll Over Protection System (ROPS) designed to reduce the risk of injury during rollovers.',
      'Chassis Structural Reinforcement: Provides additional stiffness and structural integrity to the vehicle chassis.',
      'Optimized Material Selection: Uses CDS BS4 T45 (high-strength steel alloy) to balance strength and mass.',
      'FIA Regulation Compliance: Designed for adequate mounting while adhering to FIA design regulations.',
      'Validated Crashworthiness: Structural integrity confirmed through Finite Element Method (FEM) simulation under Vertical and Angled Load tests.',
      'Minimal Deflection: Achieved low maximum deflections under significant structural loads.'
    ],
    challenges: 'The results demonstrate that the ROPS design effectively meets the structural requirements for a certified crashworthiness component. The low deflection values under significant vertical and angled loads indicate a high degree of stiffness and energy absorption, successfully achieving the projects goal of improving chassis rigidity and occupant protection.'
  },
  
];